<ion-header>
  <ion-toolbar class="ion-text-center ion-no-padding-top-important">
    <div class="vertical-align-content">
      <ion-icon color="danger" name="warning-outline"></ion-icon>
      <ion-text class="header-title ion-no-margin">{{ 'COMPONENTS.MODALS.ATTENTION' | translate }}</ion-text>
    </div>
    <ion-icon class="close" slot="end" name="close" (click)="cancel()"></ion-icon>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div height-100 flex flex-column class="ion-justify-content-between">
    <ion-text class="info">
      {{ 'COMPONENTS.MODALS.FOR_BETTER_VIEW' | translate }}
      <ion-text class="orientation" color="primary">
        {{ 'COMPONENTS.MODALS.FOLLOWING_INSTRUCTIONS' | translate }}
      </ion-text>
      {{ 'COMPONENTS.MODALS.ACCORDING_TO_EXAMPLES' | translate }}
    </ion-text>

    <ion-grid margin-auto>
      <ion-row class="ion-align-items-center ion-justify-content-content-between">
        <ion-col *ngIf="isMobile" class="ion-text-center ion-margin-bottom " sizeLg="4" sizeMd="4" sizeXl="4" sizeSm="12" sizeXs="12">
          <ion-title class="ion-no-padding title">
            {{ 'COMPONENTS.MODALS.EXAMPLE' | translate }} 1
          </ion-title>
        </ion-col>

        <ion-col sizeLg="4" sizeMd="4" sizeXl="4" sizeSm="12" sizeXs="12">
          <ion-title *ngIf="!isMobile" class="ion-no-padding title">
            {{ 'COMPONENTS.MODALS.EXAMPLE' | translate }} 1
          </ion-title>
          <ion-text class="icon-align subtitle">
            <ion-icon color="success" name="checkmark-circle"></ion-icon>
            <div>{{ 'COMPONENTS.MODALS.HORIZONTAL_PHOTOS' | translate }}</div>
          </ion-text>
          <ion-img src="assets/png/horizontal.png"></ion-img>
        </ion-col>

        <ion-col class="ion-text-center" sizeLg="4" sizeMd="4" sizeXl="4" sizeSm="12" sizeXs="12">
          <ion-text color="primary" class="divider-text">{{ 'COMPONENTS.MODALS.OR' | translate }}</ion-text>
        </ion-col>

        <ion-col *ngIf="isMobile" class="ion-text-center ion-margin-bottom " sizeLg="4" sizeMd="4" sizeXl="4" sizeSm="12" sizeXs="12">
          <ion-title class="ion-no-padding title">
            {{ 'COMPONENTS.MODALS.EXAMPLE' | translate }} 1
          </ion-title>
        </ion-col>

        <ion-col sizeLg="4" sizeMd="4" sizeXl="4" sizeSm="12" sizeXs="12">
          <ion-title *ngIf="!isMobile" class="ion-no-padding title">
            {{ 'COMPONENTS.MODALS.EXAMPLE' | translate }} 2
          </ion-title>
          <ion-text class="icon-align subtitle">
            <ion-icon color="success" name="checkmark-circle"></ion-icon>
            <div>{{ 'COMPONENTS.MODALS.VERTICAL_PHOTOS' | translate }}</div>
          </ion-text>
          <ion-img src="assets/png/vertical.png"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <footer class="ion-text-end ion-padding" max-width>
      <ion-button
        class="understood-button"
        expand="block"
        color="primary"
        responsive-button
        (click)="validate()"
      >
        {{ 'COMPONENTS.MODALS.UNDERSTOOD' | translate }}
      </ion-button>
    </footer>
  </div>
</ion-content>
